import { useLocales } from '@sevenrooms/locales'
import { IconButton } from '@sevenrooms/ui-kit/form'
import { Box, HStack } from '@sevenrooms/ui-kit/layout'
import { Text } from '@sevenrooms/ui-kit/typography'
import { reservationWidgetMessages } from '../../../../reservationWidgetMessages'

interface PartySizeSelectorProps {
  value: number
  min: number
  max: number
  onChange: (value: number) => void
  disabled?: boolean
}

export function PartySizeSelector({ value, min, max, onChange, disabled }: PartySizeSelectorProps) {
  const { formatMessage } = useLocales()
  const formattedValue = `${value} ${
    value === 1 ? formatMessage(reservationWidgetMessages.commonGuestLabel) : formatMessage(reservationWidgetMessages.commonGuestsLabel)
  }`
  return (
    <HStack justifyContent="space-between" alignItems="center">
      <Box>
        <IconButton
          data-test="sr-previous-party-size-button"
          borderType="square"
          icon="VMSWeb-chevron-left"
          disabled={disabled || value === min}
          onClick={() => onChange(value - 1)}
        />
      </Box>
      <Text textStyle="h3" textTransform="capitalize" data-test="sr-party-size-selector-value">
        {formattedValue}
      </Text>
      <Box>
        <IconButton
          data-test="sr-next-party-size-button"
          borderType="square"
          icon="VMSWeb-chevron-right"
          disabled={disabled || value === max}
          onClick={() => onChange(value + 1)}
        />
      </Box>
    </HStack>
  )
}
